import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CalendarPickerComponent } from 'app/calendar-components/calendar-picker/calendar-picker.component';
import { BehaviorSubject, take } from 'rxjs';
import { CalendarPickerService } from '../services/calendar-picker.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-calendar-input',
	template: ` <div class="tw-flex tw-flex-col tw-gap-3" *ngIf="control | formValue | async as formControl">
		<div *ngIf="label" class="tw-text-navy-500 tw-text-base tw-font-semibold">{{ label }}</div>
		<div
			#inputField
			class="tw-h-10 tw-px-3 tw-flex tw-items-center tw-border tw-border-solid tw-text-navy-500 tw-rounded-lg tw-bg-gray-050"
			[ngClass]="{
				'tw-border-gray-150': !(control.errors && control.touched) && !(focused | async),
				'tw-bg-white tw-border-navy-500 tw-shadow-focus': (focused | async),
				'tw-border-red-500 tw-shadow-error': control.errors && control.touched
			}"
			(click)="showCalendar()">
			<span *ngIf="control.value; else placeholderText" class="tw-flex tw-justify-between tw-items-center tw-w-full">
				{{ formControl.value.toDate() | date : 'MMM d, YYYY' }}
				<bp-icon icon="chevron-expand" class="tw-text-gray-500"></bp-icon>
			</span>
			<ng-template #placeholderText>
				<span class="tw-text-gray-500 tw-flex tw-justify-between tw-items-center tw-w-full">
					{{ placeholder }}
					<bp-icon icon="chevron-expand"></bp-icon>
				</span>
			</ng-template>
		</div>
		<div *ngIf="control.errors && control.touched" class="tw-text-red-500 tw-flex tw-text-sm">
			<bp-icon icon="error-02" size="16" class="tw-mr-1"></bp-icon>
			<span *ngFor="let error of control.errors | keyvalue">{{ error.value }}.&nbsp;</span>
		</div>
	</div>`,
})
export class SpCalendarInputComponent {
	@Input() label: string | undefined;
	@Input() placeholder = 'Select a date';
	@Input() control!: FormControl<moment.Moment>;
	@Input() calendarPickerConfig: Partial<CalendarPickerComponent> = {};
	@Input() setCallback: (($event: moment.Moment[]) => void) | undefined;
	@ViewChild('inputField') inputField!: ElementRef;

	focused = new BehaviorSubject<boolean>(false);

	constructor(private calendarPickerService: CalendarPickerService) {}

	showCalendar(): void {
		this.focused.next(true);
		const calendar = this.calendarPickerService.showCalendar(
			this.inputField,
			[this.control.value],
			this.calendarPickerConfig,
			this.closeCalendar.bind(this)
		);

		calendar.dateSelected.pipe(take(1)).subscribe((selectedDates: moment.Moment[]) => {
			if (this.setCallback) {
				this.setCallback(selectedDates);
			} else {
				this.control.setValue(selectedDates[0].startOf('day'));
			}
			this.control.markAsTouched();
		});
	}

	closeCalendar(): void {
		this.focused.next(false);
	}
}
